import { env } from '@/config/env';
import { useI18n } from '@/i18n/context';
import styles from './StagingRibbon.module.css';

/**
 * Staging review mode (CLAUDE.md §5): one discreet, always-visible indicator
 * that replaces every inline approval marker. Never rendered in production.
 */
export function StagingRibbon() {
  const { t } = useI18n();
  if (!env.reviewMode) return null;
  return (
    <>
      {/* Phones: keeps the end of every page clear of the fixed strip. */}
      <div className={styles.spacer} aria-hidden="true" />
      <p className={styles.ribbon} role="note" data-staging-ribbon="">
        <span className={styles.dot} aria-hidden="true" />
        {t.common.stagingRibbon}
      </p>
    </>
  );
}
